module.exports = __webpack_public_path__ + "static/front/img/banner-1.5d722fbd.jpg";